import axios from 'axios'
import { DATAMASTER_ENDPOINT } from '../../endpoints'

export async function getReferencePrices( versionId, queryString = ''){  
    let results = ''
    try {
        results = await axios.get(`${DATAMASTER_ENDPOINT}/${versionId}/referencePrices${queryString}`)
    } catch (error) {
        results = error.message
    }
    return results
}